// extracted by mini-css-extract-plugin
module.exports = {"layout":"_4b8b8b4","header":"_fed9e7e","main":"_3abfca4","betSlipHidden":"_f379366","betSlipOpen":"_794feb5","headerBetSlipOpen":"_7432ffd"};